import {createContext, ReactNode} from "react";

const VITE_API_BASE_URL = import.meta.env.VITE_API_BASE_URL + '/api'

interface IPaymentContextProps {
    createStripePaymentIntent: (cost: number, currency: string) => Promise<Response>;
    createKlarnaPaymentIntent: (cost: number, currency: string) => Promise<Response>;
}

const PaymentContext = createContext<IPaymentContextProps>({} as IPaymentContextProps)

interface IPaymentProviderProps {
    children: ReactNode
}

export const PaymentProvider = ({children}: IPaymentProviderProps) => {

    const createStripePaymentIntent = (cost: number, currency: string) => {
        return fetch(`${VITE_API_BASE_URL}/create-payment-intent`, {
            method: "POST",
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                amount: cost,
                currency: currency,
            })
        })
    }

    const createKlarnaPaymentIntent = (cost: number, currency: string) => {
        return fetch(`${VITE_API_BASE_URL}/create-klarna-payment-intent`, {
            method: "POST",
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                amount: cost,
                currency: currency,
            })
        })
    }

    return (
        <PaymentContext.Provider
            value={{createStripePaymentIntent, createKlarnaPaymentIntent}}>
            {children}
        </PaymentContext.Provider>
    )
}

export default PaymentContext;